import { Close } from "@mui/icons-material";
import {
  Box,
  SxProps,
  Dialog,
  DialogTitle,
  IconButton,
  Divider,
  DialogContent,
  DialogActions,
  Theme,
  Breakpoint,
} from "@mui/material";

export default function Modal({
  title,
  isOpen,
  handleCloseModal,
  dataTestId,
  content,
  footerContent,
  footerDivider = false,
  sx,
  size,
  disableEnforceFocus,
}: {
  title: string;
  isOpen: boolean;
  handleCloseModal:
    | ((event: NonNullable<unknown>, reason?: "backdropClick" | "escapeKeyDown") => void)
    | (() => void);
  dataTestId: string;
  content: string | JSX.Element | JSX.Element[];
  footerContent?: string | JSX.Element | JSX.Element[];
  footerDivider?: boolean;
  sx?: SxProps<Theme>;
  size?: Breakpoint | undefined;
  disableEnforceFocus?: boolean;
}) {
  return (
    <Dialog
      open={isOpen}
      fullWidth
      maxWidth={size ?? "sm"}
      onClose={handleCloseModal}
      data-test={dataTestId + "-modal"}
      disableEnforceFocus={disableEnforceFocus}
      sx={sx}
    >
      <DialogTitle data-test={dataTestId + "-title"}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span id={dataTestId + "-label"}>{title}</span>
          <IconButton data-test={"close-" + dataTestId} aria-label="Close Dialog" onClick={handleCloseModal}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider sx={{ maxWidth: "calc(100% - 48px)", mx: "auto", my: 0, width: 1 }} />
      <DialogContent sx={{ pt: "1rem" }}>{content}</DialogContent>
      {footerContent && (
        <>
          {footerDivider && <Divider sx={{ maxWidth: "calc(100% - 48px)", mx: "auto", my: 0, width: 1 }} />}
          <DialogActions sx={{ paddingRight: "1rem", paddingBottom: "1rem" }}>{footerContent}</DialogActions>
        </>
      )}
    </Dialog>
  );
}
